import { render, staticRenderFns } from "./202311.vue?vue&type=template&id=d5ba8686&scoped=true&"
import script from "./202311.vue?vue&type=script&lang=js&"
export * from "./202311.vue?vue&type=script&lang=js&"
import style0 from "./202311.vue?vue&type=style&index=0&id=d5ba8686&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ba8686",
  null
  
)

export default component.exports